import { Navigate, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import i18next from "i18next";
import AIWorks_T_C from "../../assets/AIWORKS_T&C.pdf";
import { Checkbox, DefaultButton } from "@fluentui/react";
import { saveTermsAcceptance } from "../../api/api";
import { userInfo } from "../../authConfig";
import styles from "../updates/Update.module.css";
import HeaderInfo from "../layout/HeaderInfo";
type TermsAndConditionsProps = {
    onAccept: () => void;
};

const TermsAndConditions = ({ onAccept }: TermsAndConditionsProps) => {
    const [isAgreeCheck, setIsAgreeCheck] = useState(false);
    const navigate = useNavigate();

    const checkIsUserAgree = () => {
        onAccept();
        saveTermsAcceptance();
        localStorage.setItem("disclaimerHide", "initial");
        navigate("/assistant/chat");
    };

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const handlePopState = (event: PopStateEvent) => {
            navigate("/assistant/chat");
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [navigate]);

    return (
        <div style={{ display: "flex" }}>
            <header className={styles.header} role={"banner"}>
                <div className={styles.headerContainer}>
                    <HeaderInfo />
                </div>
            </header>
            {userInfo.terms_accepted !== "accepted" ? (
                <div>
                    <div style={{ margin: "70px 50px 5px 55px", alignItems: "center", fontWeight: "bold" }}>{i18next.t("homepage.termsHeader")}</div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            border: "1px solid black",
                            marginRight: "50px",
                            marginLeft: "50px"
                        }}
                    >
                        <embed
                            id="pdf-embed"
                            src={AIWorks_T_C}
                            type="application/pdf"
                            width={`${window.innerWidth - 110}`}
                            height={`${window.innerHeight - 155}`}
                        ></embed>
                    </div>
                    <div style={{ paddingTop: "15px", display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "15px" }}>
                        <Checkbox label={i18next.t("homepage.terms")} checked={isAgreeCheck} onChange={() => setIsAgreeCheck(!isAgreeCheck)} />
                        <div style={{ marginLeft: "15px" }}>
                            <DefaultButton
                                disabled={!isAgreeCheck}
                                style={!isAgreeCheck ? { backgroundColor: "grey" } : { backgroundColor: "blue", color: "white" }}
                                onClick={() => checkIsUserAgree()}
                            >
                                <span style={{ color: "white", textDecoration: "none" }}>{i18next.t("homepage.agree")}</span>
                            </DefaultButton>
                        </div>
                    </div>
                </div>
            ) : (
                <Navigate to="/assistant/chat" replace />
            )}
        </div>
    );
};

export default TermsAndConditions;
